/**
 * CMS Client for JT transportsejlads
 * Fetches data from Auxo CMS public endpoints
 */

const API_BASE = 'https://api.dev.auxo.dk';

export const STATIC_FALLBACK_GALLERIES = {
  'baadtransport-galleri': {
    title: 'Bådtransport og sejlads på vandet',
    description: 'Billeder af bådtransport og sejlads på vandet i de danske farvande.',
    images: [
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg',
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1126381112.jpg',
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1266713739.jpg'
    ]
  },
  'referencer-galleri': {
    title: 'Seneste referencer og projekter',
    description: 'Mit senest udførte arbejde – se de seneste referencer her.',
    images: [
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg',
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1126381112.jpg',
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1266713739.jpg'
    ]
  },
  'om-mig-galleri': {
    title: 'Om mig og maritim erfaring',
    description: 'Erfaring, uddannelse som skipper og duelighedsbevis – din garanti for sikker sejlads.',
    images: [
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1126381112.jpg',
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg',
      'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-1266713739.jpg'
    ]
  }
};

export async function fetchCmsGallery(gallerySlug) {
  try {
    const res = await fetch(`${API_BASE}/public/content/galleri`);
    if (res.ok) {
      const items = await res.json();
      const match = items.find(
        (item) => item.slug?.da === gallerySlug || item.slug === gallerySlug || item.category === gallerySlug
      );
      if (match && match.images && match.images.length > 0) {
        return match;
      }
    }
  } catch (err) {
    console.warn('CMS gallery fetch error, using fallback:', err);
  }
  return STATIC_FALLBACK_GALLERIES[gallerySlug] || STATIC_FALLBACK_GALLERIES['baadtransport-galleri'];
}

export const STATIC_NAV_ITEMS = [
  { label: 'Forside', url: '/' },
  { label: 'Bådtransport', url: '/baadtransport' },
  {
    label: 'Referencer',
    url: '/referencer',
    children: [
      { label: 'Alle referencer', url: '/referencer' },
      { label: 'Reference detaljer', url: '/reference' }
    ]
  },
  { label: 'Om mig', url: '/om-mig' },
  { label: 'Kontakt', url: '/kontakt' }
];

export async function fetchCmsNavigation() {
  try {
    const res = await fetch(`${API_BASE}/public/content/navigation`);
    if (res.ok) {
      const items = await res.json();
      if (Array.isArray(items) && items.length > 0) {
        return items.sort((a, b) => (a.order || 0) - (b.order || 0));
      }
    }
  } catch (err) {
    console.warn('CMS navigation fetch error, using static fallback:', err);
  }
  return STATIC_NAV_ITEMS;
}
